import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import { applySeo } from '@/seo/client';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/anfrage', // <-- NEUE ROUTE
    name: 'landingpage',
    component: () => import('../views/Landingpage.vue'),
  },

  {
    path: '/admin/images',
    name: 'adminImageView',
    component: () => import('../views/admin/ImageView.vue'),
  },

  {
    path: '/about-me',
    name: 'about',

    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/pets',
    name: 'pets',

    component: () => import('../views/PetsView.vue'),
  },
  {
    path: '/art',
    name: 'art',

    component: () => import('../views/ArtView.vue'),
  },
  {
    path: '/tierportraets',
    name: 'petPortraits',
    component: () => import('../views/PetPortraitsView.vue'),
  },
  {
    path: '/auftragskunst',
    name: 'commissions',
    component: () => import('../views/CommissionsView.vue'),
  },
  {
    path: '/appointments',
    name: 'appointments',

    component: () => import('../views/Appointments.vue'),
  },
  {
    path: '/appointment/:id',
    name: 'appointmentView',

    component: () => import('../views/AppointmentView.vue'),
  },
  {
    path: '/tattoos',
    name: 'tattoo',

    component: () => import('../views/TattooView.vue'),
  },
  {
    path: '/studio',
    name: 'studio',

    component: () => import('../views/StudioView.vue'),
  },
  {
    path: '/impressum',
    name: 'impressum',

    component: () => import('../views/Impressum.vue'),
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',

    component: () => import('../views/Datenschutz.vue'),
  },
  {
    path: '/:pathMatch(.*)*', // catch-all Route
    name: 'notFound',
    component: () => import('../views/NotFoundView.vue'),
  },
];

export default function createSiteRouter(history = createWebHistory(process.env.BASE_URL)) {
  const router = createRouter({
    history,
    routes,
    async scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      if (to.hash) {
        // Wait for the route transition before resolving an anchor on the new page.
        await new Promise((resolve) => setTimeout(resolve, 200));
        const id =
          to.path === '/tattoos' && to.hash === '#anfrage-formular'
            ? 'terminvergabe'
            : decodeURIComponent(to.hash.slice(1));
        const el = document.getElementById(id);
        if (el)
          return {
            el,
            top: 150,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          };
      }
      return { top: 0, behavior: 'instant' };
    },
  });

  router.afterEach((to) => applySeo(to.path));
  return router;
}
